import { useRef } from "react";

import { Flex, Icon, Menu, ToggleButton, TooltipWrapper } from "@theorgchartdev/storybook";
import { getHoverTipContent } from "@/Utils/Misc";
import {
  DoMergeCells,
  DoUnmergeCells,
  IsMergeDisabled,
  ToggleMergeCells
} from "@/appComponents/Blocks/Composites/LayoutHoverToolbar/Utils";
import { appstr } from "@coreapp/utils/appstr";

export const MergeCellMenu = props => {
  const openCtrlRef = useRef(null);

  const BLEMergeOptions = [
    {
      value: "mergeall",
      clickHandler: DoMergeCells,
      disabled: IsMergeDisabled
    },
    {
      value: "unmergecells",
      clickHandler: DoUnmergeCells,
      disabled: IsMergeDisabled
    }
  ];

  return (
    <Flex gap={"5px"} alignItems={"center"}>
      <ToggleButton
        key={0}
        icon={"arrows-left-right-to-line"}
        value={"merge-selected-cells"}
        data-testid={`${props?.dataTestIdPrefix}-merge-btn`}
        tooltipProps={getHoverTipContent("Merge cells")}
        checked={props?.isMerged}
        disabled={IsMergeDisabled("mergeany")}
        onToggle={ToggleMergeCells}
      />
      <Menu
        openCtrlRef={openCtrlRef}
        dataTestId={`${props?.dataTestIdPrefix}-merge-menu`}
        optionSize={"small"}
        trigger={
          <TooltipWrapper
            tooltipProps={{
              ...getHoverTipContent("Select merge type"),
              referenceOpenCtrlRef: openCtrlRef
            }}
          >
            <Icon
              className={"split-button-arrow"}
              name={"caret-down"}
              size={"xsmall"}
              disabled={IsMergeDisabled("mergeany")}
            />
          </TooltipWrapper>
        }
        options={BLEMergeOptions.map(item => {
          return { ...item, label: appstr(item.value), disabled: item?.disabled(item.value) };
        })}
      />
    </Flex>
  );
};
